import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

type PageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
  crumb: string;
};

export default function PageHero({ eyebrow, title, description, crumb }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-primary-950 pt-28 md:pt-36">
      <div className="pointer-events-none absolute inset-0 grid-paper opacity-[0.12]" aria-hidden="true" />
      <div
        className="pointer-events-none absolute -right-24 -top-28 h-96 w-96 rounded-full bg-primary-800/50 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl"
        aria-hidden="true"
      />

      <div
        className="pointer-events-none absolute left-5 top-24 hidden h-12 w-12 rounded-tl-lg border-l border-t border-accent-400/30 lg:block"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute bottom-14 right-6 hidden h-12 w-12 rounded-br-lg border-b border-r border-accent-400/30 lg:block"
        aria-hidden="true"
      />

      <div className="shell relative pb-14 md:pb-20">
        <Reveal>
          <nav
            aria-label="Sayfa yolu"
            className="flex flex-wrap items-center gap-2 text-xs font-medium text-background-200/70"
          >
            <Link to="/" className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300">
              Anasayfa
            </Link>
            <i className="ri-arrow-right-s-line text-sm" aria-hidden="true" />
            <span className="whitespace-nowrap text-background-100">{crumb}</span>
          </nav>
        </Reveal>

        <Reveal delay={70}>
          <span className="mt-7 inline-flex items-center gap-2 rounded-full border border-background-50/25 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-accent-300">
            <i className="ri-focus-3-line text-sm" aria-hidden="true" />
            {eyebrow}
          </span>
        </Reveal>

        <Reveal delay={120}>
          <h1 className="mt-6 max-w-4xl font-heading text-3xl font-medium leading-[1.08] tracking-tight text-background-50 md:text-5xl lg:text-[3.4rem]">
            {title}
          </h1>
        </Reveal>

        <Reveal delay={170}>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200/85 md:text-base">
            {description}
          </p>
        </Reveal>
      </div>

      <div
        className="h-px w-full bg-gradient-to-r from-transparent via-accent-500/40 to-transparent"
        aria-hidden="true"
      />
    </section>
  );
}